angular.module('ui2.0Directives')
.directive('commentValue', ['$sce', function ($sce){
	return{
		restrict:'C',
		scope:{
			valueInfo :'<',
			valueLength : '='

		},
		link:function($scope,element,attrs){
			$scope.valueInfo = ($sce.getTrustedHtml($scope.valueInfo));
			var x = angular.element('<div/>');
			x.html($scope.valueInfo);
			$scope.valueLength = x.text().length;
		}
	}
}])
.directive('commentList', ['$http','$rootScope','entityFactory','$timeout','$sce','$filter','formService','$uibModal','$q','fileService', function ($http,$rootScope,entityFactory,$timeout,$sce,$filter,$formService,$modal,$q,fileService){
	return{
		restrict :'AE',
		scope : {
			entityTypeId :'<',
			highLightCommentBox:'&',
			showPageDataLoaded :'=',
            isScrollDisabled :'=',
            togglePropValue:'&',
			showpageData : '=',
            parentFieldObj : '=',
            globalData: '=',
            treeDefInstance : '='
		},
		// templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/commentAndAttachmentList.html"),
		link : function($scope,element,attrs){
            $scope.$on('$destroy', function() {
                updateCmnt();
                loadComment();
                delete $rootScope.commentListScope;
            });
			$scope.commentFieldMapping = {'document':3991,'comment':3992,"completed_by":3993,"user_date":3994,"shared":18299,"status":3995,"privacy":14364,"isDraft":14535};
			/** commentDataScope : '1' means comment and attachment, '2': comment , '3':only attachments*/
			$scope.commentDataScope = 1;
			$scope.intl_msg=$rootScope.intl_msg;
			$scope.commentsList =[];
			$scope.attachmentsList = [];
			$scope.comFieldMap={};
			$scope.flatAttachmentArray = false;
			var privateFuncObj = {};
			$scope.commentsOn = true;
			$scope.attachmentsOn = true;
            $scope.allCommunication = [];
            $scope.isScrollDisabled = true;
            $scope.isFirstCallComplete = false;
            $scope.selectedFileType='All Files';
            $scope.showfileTypeDD = false;
            $scope.flatattachmentsList=[];
            $scope.appliedFilter = false;
            var sc = $("#data-ng-app").scope();
            $scope.mobileView = sc.mobileView;
            $scope.enableInheritFile = sc.layoutData.headerBar.enableInheritFile;
            sc.enableInheritFile = $scope.enableInheritFile;
            $scope.enableMoveToTree = sc.layoutData.headerBar.enableMoveToTree;
            sc.enableMoveToTree = $scope.enableMoveToTree;
            $scope.enableCommDownload= sc.layoutData.headerBar.enableCommunicationDownload;
            $scope.enableSendForSig = ( $scope.sendForDigitalSignature && window.location.href.indexOf('cdr')==-1);
            sc.enableSendForSig = $scope.enableSendForSig;
            if(window.location.hash.indexOf('tblcdr')>-1){
                // on cdr no tool button or send for sig
                $scope.enableSendForSig =false
            }
            $scope.inheritFileFieldObj = null;
            $scope.moveToTreeFieldObj = null;
            $scope.sendForSigFieldObj =  null;
            $scope.showDocumentTags = false;
            $scope.parentFieldObj.fields.forEach(function(field,index){
                if(field.properties && field.properties.stepperName=="inheritFiles"){
                    $scope.inheritFileFieldObj = field;
                    sc.inheritFileFieldObj = $scope.inheritFileFieldObj;
                }
                else if(field.properties && field.properties.stepperName=="moveToTree"){
                    $scope.moveToTreeFieldObj = field;
                    sc.moveToTreeFieldObj = $scope.moveToTreeFieldObj;
                }
                if ( field && field.properties && field.properties.sendForSignature == true ) {
                    field.fields.forEach(function (childField, index) {
                        if ( childField.name == "sendForSignature"  ) {
                            modifyDataURL(childField);
                            if(!$scope.sendForSigFieldObj){
                                $scope.sendForSigFieldObj = {};
                            }
                            $scope.sendForSigFieldObj = {"fields":[childField],"id":childField.id};
                            sc.sendForSigFieldObj = $scope.sendForSigFieldObj;
                        }
                    });
                }
                if ( field && field.properties && field.properties.documentTags == true ) {
                    field.fields.forEach(function (childField, index) {
                        if ( childField.name == "documentTags"  ) {
                            $scope.showDocumentTags = true;
                        }
                    });
                }
            });
            function modifyDataURL(_field){
                _field.dataURL = _field.dataURL+sc.data.entityTypeId.values+'/'+sc.data.id.values;
            };
            $scope.showToolsBox = false;
            $scope.commentLoaded = false;
            var dataBackup = {};

            $scope.updateFlatattachmentsList = function() {
                $scope.filteredAttachmentsList = angular.copy($scope.flatattachmentsList);

                if($scope.selectedFileType=='All Files'){
                    $scope.flatattachmentsList = $scope.filteredAttachmentsList;
                }else{
                    $scope.flatattachmentsList = $filter('filter')($scope.filteredAttachmentsList, {'classification':$scope.selectedFileType});
                }
                $rootScope.commentListScope = $scope
            }

            $scope.hideInvalidLinks = function () {
                if(window.emailTokenValidation) {
                    var invalidLinks = $("a:not(.communication_expandIcon a):not(.filter li a):not(.toggleBtn):not(.rightSec a):not(.secuirity a):not(.button-groups a):not(.mesh-list a)");
                    invalidLinks.attr("href","javascript:void(0)").attr("ng-href","javascript:void(0)");
                    invalidLinks.addClass("notValidInMail");
                }
            };

			/******************************************************************************************/
			//********************************PRIVATE FUNCTIONS***************************************//
			/****************************************************************************************/

			/*** makeRequestToApi : function to make an ajax call **/
			privateFuncObj.makeRequestToApi  = function(requestObj){
				return $.ajax({
                    dataType: 'json',
                    contentType: "application/json;charset=UTF-8",
                    type: requestObj.method,
                    url: requestObj.url,
                    data: JSON.stringify(requestObj.data)
                }).then(function(res){
                	return {"data":res};
				}).catch((error) => window.systemWarning(error));
			};
			/**************** End of makeRequestToApi *************/

			/*** privateFuncObj.createPrivacyProp : function to create privacy dict for each comment from the privacy string value **/
			privateFuncObj.createPrivacyProp = function(obj){
				var privacyProp = obj.split(":;"), privacyPropList = {};
				privacyPropList.auditLogId = privacyProp[2];
				privacyPropList.entityTypeId = privacyProp[1];
				privacyPropList.isPrivate = (privacyProp[0]).toLowerCase() == "false" ? false :true;
				privacyPropList.isPrivacyEditable = (privacyProp[3] && (privacyProp[3]).toLowerCase()) == "yes" ? true : false;
				return privacyPropList;
			}
			/******************** End of privateFuncObj.createPrivacyProp *****************/

			/*** privateFuncObj.createDocVersionFileName : function to create the documents dict for versioned files from document string value **/
			privateFuncObj.createDocVersionFileName = function(docObj,privacyObj){
				var url = "/tblauditlogs/drafts/"+privacyObj.entityTypeId+"/"+privacyObj.auditLogId,
		    		docVersioningPromise = entityFactory.getDataJson(url , "GET"),
		    		docsList=[],docs,otherdoclist;
                docVersioningPromise.then(function(res){
		    		docs = res.data.data;
		    		if(!_.isEmpty(docs)){
		    			for(var index=0;index < docs.length;index++){
			    		//for(let [index,items] of docs.entries()){
			    			docsList[index] = {};
			    			if(docs && docs[index]){
                                docsList[index]['fileName'] = docs[index].documentName;
                                docsList[index]['documentTags'] = docs[index].documentTags;
                                docsList[index]['version'] = docs[index].version;
                                docsList[index]['extn'] = docs[index].documentName.split(/[. ]+/).pop();
                                docsList[index]['docId'] = docs[index].documentFileMetadata.split(':;')[1];
                                docsList[index]['fileId'] = docs[index].documentFileMetadata.split(':;')[2];
                                docsList[index]['downloadLink'] = appName+ "/download/communicationdocument?id=" + docsList[index]['docId'] + "&entityTypeId=78&entityType.id=" + docs[index].documentFileMetadata.split(':;')[0]+"&fileId="+docsList[index]['fileId'];
                                if( $scope.entityTypeId != '12' && $scope.entityTypeId != '13'){
                                    docsList[index]['classification']= privateFuncObj.createFileClassification(docs[index].classification && docs[index].classification.split(':;'),docsList[index]);
                                }
                            }

			    		}
		    		}else{
		    			privateFuncObj.createFileNames(escapeHtml(docObj),docsList);
		    		}


                    $timeout(function() {
                        // Populating attachments lists directly after the comments call after createDocVersionFileName
                        $scope.flatattachmentsList = privateFuncObj.createFlatArray($scope.attachmentsList, $scope.comFieldMap['document'].id);
                        $scope.updateFlatattachmentsList();
                        $scope.commentDataLoaded = true;
                        $scope.$apply();
                        // console.log('ATTACHMENTS APPLY -- --- --- ---');
                    }, 0);
		    	});

		    	return docsList;
			}
			/******************** End of privateFuncObj.createDocVersionFileName *****************/

			/*** privateFuncObj.createFileClassification : function to create classification value of files ***/
			privateFuncObj.createFileClassification = function(propArr,docObj){
				let classificationArr = ['Financial','Legal','Business Case'];
				let fileClassification ;
				if(propArr && propArr.length) {
                    fileClassification = propArr.map(function (item, idx) {
                        if (item == 'true') {
                            docObj[classificationArr[idx]] = true;
                            return classificationArr[idx];
                        }
                    }).filter(function (item) {
                        return item;
                    }).join(',');
                }
				return fileClassification;
			}
			/******************** End of privateFuncObj.createFileClassification *****************/

			/*** privateFuncObj.createFileNames : function to create document value dict for nonversioned documents or if the isDraft value is false **/
			privateFuncObj.createFileNames = function(obj,docsList){
				var docs=obj.split("###"),tempList, docsList = !docsList ? [] : docsList;
				for(var i=0;i<docs.length;i++){
                    tempList = docs[i].split(":;");
                    if(tempList.length>2) {
                        docsList[i] = {};
                        docsList[i]['fileName'] = tempList[1] + '.' + tempList[2];
                        docsList[i]['extn'] = tempList[2];
                        docsList[i]['docId'] = tempList[0];
                        docsList[i]['fileId'] = tempList[4];
                        docsList[i]['downloadLink'] = appName + "/download/communicationdocument?id=" + tempList[0] + "&entityTypeId=78&entityType.id=" + tempList[3] + "&fileId=" + tempList[4];
                    }
				}
				return docsList;
			};
			/******************** End of privateFuncObj.createFileNames *****************/

			/*** privateFuncObj.createUserInitals : function to create userInitials from user name ***/
			privateFuncObj.createUserInitals = function(userName){
				return globalFunc.getUserInitials(userName);
			}
			/******************** End of privateFuncObj.createUserInitals *****************/

			/*** privateFuncObj.createFlatArray : function to create flat array of attachemnts ***/
			privateFuncObj.createFlatArray = function(x,docid){
                let y = _.flatMap(x, function(item) {
                    return _.map(item[docid].value, function(docs) {
                        let itemsKeys = _.filter(Object.keys(item),function(o){return (o != docid && o !=='$$hashKey');});
                        return _.defaults(_.transform(itemsKeys,function(result,n){result[n]=item[n];},{}), docs);
                    });
                });
                return y;
			};
			/******************** End of privateFuncObj.createFlatArray *****************/
			var requestObj;
			var updateCmnt= $scope.$on('updateComment',function(event,isCommentUpdate, refreshData){
                $scope.commentDataScope = 1;
			});
			var loadComment = $scope.$on('loadComment',function(e){
			    if(!$scope.commentDefInstance){
                    $scope.commentDefInstance = $q.defer();
                }
			    if(!$scope.commentLoaded){
                    $scope.commentDefInstance.resolve("loadComment")
                }
            })
			$scope.setCommDataScope = function(val){
				if(val == 3){
					$scope.attachmentsOn = !$scope.attachmentsOn;
				}
				else if(val == 2){
					$scope.commentsOn = !$scope.commentsOn;
				}
				/*if($scope.commentsOn && $scope.attachmentsOn){
					$scope.commentDataScope = 1;
				}
				else if(!$scope.commentsOn && !$scope.attachmentsOn){
					$scope.commentDataScope = 4;
				}else{
					$scope.commentDataScope = val;
				}*/

                $scope.commentDataScope = val;
                if(val == 1){
                    $scope.selectedFileType='All Files';
				}
				if(val == 3 && _.keys($scope.comFieldMap).length){
					$scope.flatattachmentsList = privateFuncObj.createFlatArray($scope.attachmentsList, $scope.comFieldMap['document'] ?$scope.comFieldMap['document'].id : null);
					$scope.updateFlatattachmentsList();
				}
                setTimeout(function () {
                    $scope.hideInvalidLinks();
                },100)
			};
			$scope.storePrivacy = function(event,privacyObj){

                if (event.target) {
                    const value = event.target.getAttribute("value") == "false" ? false : true;
                    $scope.togglePrivacyOption(privacyObj)
                    if(value == privacyObj.isPrivate){
                        return
                    }
                    let url = "/tblauditlogs/" + privacyObj.entityTypeId + "/" + privacyObj.auditLogId + "?privacy=" + !privacyObj.isPrivate;
                    let privacyPromise = entityFactory.getDataJson(url, "GET");
                    privacyPromise.then(function (res) {
                        privacyObj.isPrivate = !privacyObj.isPrivate;
                    });
                }
            };

			$scope.togglePrivacyOption=function(privateObj){
                privateObj.show =false;
            }
            $scope.storeShared = function(sharedObj,privacyObj){
                startLoader();
                let url = "/tblauditlogs/"+privacyObj.entityTypeId+"/"+privacyObj.auditLogId+"?privacy="+privacyObj.isPrivate+"&shared="+sharedObj.value;
                let privacyPromise = entityFactory.getDataJson(url , "GET")
                privacyPromise.then(function(res){
                    stopLoader();
                });
			}
			$scope.toggleContent = function(e){
				if(angular.element(e.target).data('showmore')){
					angular.element(e.target).closest('li').find('.jx-commentValue').toggleClass('comment-fixed-height');
					angular.element(e.target).data('showmore',false);
					angular.element(e.target).html(intl_msg[27449]);


				}else{
					angular.element(e.target).closest('li').find('.jx-commentValue').toggleClass('comment-fixed-height');
					angular.element(e.target).data('showmore',true);
					angular.element(e.target).html(intl_msg[27451]+' '+intl_msg[27450]);
				}
			};
			$scope.switchOnFilters=function(){
				$scope.commentsOn = !$scope.commentsOn ;
				$scope.attachmentsOn = !$scope.attachmentsOn;
				$scope.commentDataScope = 1;

			};
            $scope.filterAttachmentsList = function (fileType,LIST_TYPE) {
                $scope.appliedFilter = true;
                var intl_file_type = {
                    'financial':4566,
                    'legal':4567,
                    'business case':4568
                }
                var classificationOpts = ['Financial', 'Legal', 'Business Case'];
                var CLASSIFICATION_STR = 'Classification';
                var DOC_TAG_STR = "docTag";
                fileType = !fileType ? '' : fileType;
                $scope.selectedFileType = fileType == '' ? 'All Files' : intl_msg[intl_file_type[fileType.toLowerCase()]];
                if ($scope.selectedFileType == 'All Files') {
                    $scope.flatattachmentsList = $scope.filteredAttachmentsList;
                }
                else if (LIST_TYPE== CLASSIFICATION_STR  && classificationOpts.indexOf(fileType) > -1) {
                    $scope.flatattachmentsList = $filter('filter')($scope.filteredAttachmentsList, {'classification': $scope.selectedFileType});
                }
                else if(LIST_TYPE == DOC_TAG_STR){
                    $scope.flatattachmentsList = $filter('filter')($scope.filteredAttachmentsList, {'documentTags': $scope.selectedFileType});
                }
            };
            $scope.openFilesSubDD = function (e) {
                if (angular.element(e.currentTarget).find('.jx-createLinkAnchor').hasClass('active')) {
                    angular.element(e.currentTarget).find('.jx-Files-subDD').slideUp();
                    angular.element(e.currentTarget).find('.jx-createLinkAnchor').removeClass('active');
                } else {
                    angular.element(e.currentTarget).find('.jx-Files-subDD').slideDown();
                    angular.element(e.currentTarget).find('.jx-createLinkAnchor').addClass('active');
                }
            };
            $scope.docTagsList = [];
			$scope.loadMoreData = function(){
				if(!$scope.isScrollDisabled && $scope.isFirstCallComplete){
                    //makeDataCallForComments();
                }else{
                    return;
                }

			};
            $scope.openInheritModal = function (fieldObj) {
                $scope.inheritFileFieldObj=fieldObj
				$scope.inheritFileFieldObj.modalTitle = intl_msg[28082] ? intl_msg[28082] : 'Inherit File'
                $scope.inheritFileModal = $modal.open({
                    template: '<document-transfer dirFor="inheritFile"></document-transfer>',
                    modal: true,
                    size: "lg",
                    keyboard: false,
                    backdrop: "static",
                    windowClass: "inheritFileModal",
                    scope:$scope
                });
			}

            $scope.openMoveToTreeModal = function (fieldObj) {
                $scope.moveToTreeFieldObj.modalTitle = intl_msg[28083] ? intl_msg[28083] : "Move to tree";
                $scope.moveToTreeModal = $modal.open({
                    template: '<document-transfer dirFor="moveToTree"></document-transfer>',
                    modal: true,
                    size: "lg",
                    keyboard: false,
                    backdrop: "static",
                    windowClass: "moveToTreeModal",
                    scope:$scope
                });
            };
            $scope.toggleDeleteBox = function (e,show,index){
                e.stopPropagation();
                var sel = angular.element(e.currentTarget).closest('li').find('.commentDeleteBox');
                show ? sel.addClass('active') : sel.removeClass('active');
                if($scope.allCommunication) {
                    var delete_id = $scope.comFieldMap.private_communication.id;
                    if($scope.allCommunication[index][delete_id].value.hasOwnProperty('show'))
                        $scope.allCommunication[index][delete_id].value.show = false;
                }
                return false;
            }
            $scope.toggleAttachmentlist = function (e,show){
                e.stopPropagation();
                var sel = angular.element(e.currentTarget).closest('.attachments');
                !sel.hasClass('active') ? sel.addClass('active') : sel.removeClass('active');
                return false;
            }

            $scope.getAttachmentLabel = function (items){
                let label = "Attachment";
                label += items.length > 1 ? 's' : '';
                return label;
            }

            $scope.deleteComment = function (e,item){
                let itemData = this.item;
                    if(_.has($rootScope, "data.id.values") && item && item.entityTypeId && item.auditLogId){
                        const isInvoiceCopy = _.find(itemData, {'columnName': 'invoicecopy'});
                        const isInvoiceCopyTrue = isInvoiceCopy && isInvoiceCopy.value;
                        let apiUrl = '/commentAttachment/delete/' + item.entityTypeId + '/' + $rootScope.data.id.values + '/'+item.auditLogId;
                        if(isInvoiceCopyTrue == "true")
                            apiUrl = SirionUtils.addQueryString(apiUrl, "isInvoiceCopy="+ isInvoiceCopyTrue);
                        $http.delete(apiUrl).then(function (result) {
                            var sel = angular.element(e.currentTarget).closest('li').find('.commentDeleteBox');
                            sel.length && sel.removeClass('active');
                            if(result.status == 200){
                                Toaster.create(intl_msg[6408]);
                                if(!$rootScope.aeDocShowPage){
                                    var showPageScope  = $(".content_container.showpage").scope();
                                    showPageScope.renderActionbuttons(showPageScope);
                                }
                                $scope.fetchFeedsData();
                                $scope.$broadcast('updateComment', true, true);
                            }else{
                                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23500], heading: intl_msg[24153]});
                            }
                        }, function (error) {
                            console.error('Data cannot be loaded due to: ' + error);
                        });
                    }
                    angular.element(e.currentTarget).closest('li').find('.commentDeleteBox').removeClass('active');
                    e.preventDefault();
                    return false;
            }

            $scope.fetchFeedsData = () => {
                if($scope.$parent.feedsResponse && $scope.$parent.feedsResponse.isCommentBoxAllowed) {
                    let entityId = $scope.$parent.data.id.values,
                        entityTypeId = $scope.$parent.data.entityTypeId.values;
                    $scope.$parent.showPageService.getFeedsData.call($scope.$parent, {entityId,entityTypeId}).then(res => {
                        if(res && res.status == 200 && !res.data.ERROR) {
                            let sc = $('ng-view').scope();
                            sc.feedsResponse = res.data.DATA;
                            sc.feedsResponse.entityTypeId = entityTypeId;
                            sc.feedsResponse.entityId = entityId;
                            window.sarc.channelBroadcast("timelineFeeds",{
                                actionType:'feedsResponseUpdate',
                                value: sc.feedsResponse
                            },'timelineFeedsSubscription')
                        }
                    })
                }
            }

            $scope.openPopupForMedia = function(e) {
                fileService.openPopupForMedia.call($scope, this, e);
            }

            $scope.closeMediaModal = function() {
                fileService.closeMediaModal.call($scope);
            }
            $rootScope.$on("update comment data scope",function(e,val){
                $scope.setCommDataScope(val);
            })
            $rootScope.commentListScope = $scope;
		}
	}
}]);
/*angular.module('ui2.0').filter('fileTypeFilter',function(){
	return function(input,ftype,enablefilter){
		var out = [];
		console.log(ftype);
		console.log(enablefilter);
		if(enablefilter || ftype=='' || ftype == undefined){
			return input;
		}else{
			angular.forEach(input, function(item){
			      if(item.hasOwnProperty(ftype) && item[ftype]){
			          out.push(item);
			        }
			      });
			return out;
		}
	}
});*/
